import { getAllSelectOptions } from "../../services/AppServices";
import {
  FETCH_APP_SELECT_OPTIONS_PENDING,
  FETCH_APP_SELECT_OPTIONS_SUCCESS,
  FETCH_APP_SELECT_OPTIONS_ERROR
} from "../../constants/actionTypes";

export function fetchSelectOptionsPending() {
  return {
    type: FETCH_APP_SELECT_OPTIONS_PENDING,
  }
}

export function fetchSelectOptionsSuccess(response) {
  const selectOptions = {};
  selectOptions['users'] = response.data.users?.map(user => { 
    return {
      value: user.id, 
      label:`${user.name}(${user.username})`,
      email: user.email,
    }
  });
  selectOptions['templates'] = response.data.templates?.map(temp => { 
    return {
      value: temp.id, 
      label: temp.name,
    }
  });
  selectOptions['positions'] = response.data.positions?.map(temp => { 
    return {
      value: temp.id, 
      label: temp.name,
    }
  });
  selectOptions['templates'] = response.data.templates?.map(temp => { 
    return {
      value: temp.id, 
      label: temp.name,
    }
  });
  return {
    type: FETCH_APP_SELECT_OPTIONS_SUCCESS,
    payload: selectOptions,
  }
}

export function fetchSelectOptionsError(error) {
  return {
    type: FETCH_APP_SELECT_OPTIONS_ERROR,
    payload: {},
    error: error
  }
}

export const fetchSelectOptions = () => {
  return async dispatch => {
    dispatch(fetchSelectOptionsPending);
    try {
      const response = await getAllSelectOptions().then(res=> res);
      dispatch(fetchSelectOptionsSuccess(response));
    } catch(e) {
      dispatch(fetchSelectOptionsError(e))
    }
  }
};

